import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { ACTIVE_STATUS, LOCKED_STATUS, VOUCHER_STATUS } from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
function HistoryCardPopup({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chỉnh sửa thẻ"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataHistory?.content}
            name="HistoryCard"
            showMoreButton
            minWidth={"1000"}
            columns={[
              {
                title: t("Mã đơn hàng"),
                field: "code",
              },
              {
                field: "clientCard.code",
                title: t("Mã thẻ trả trước"),
                render: (val) => {
                  return (
                    <div>
                      <span className="service-code">
                        {val?.clientCard?.code}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "clientCard.name",
                title: t("Tên thẻ trả trước"),
                render: (val) => {
                  return (
                    <div>
                      <span className="service-name">
                        {val?.clientCard?.name}
                      </span>
                      <div>
                        Giá trị SD:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(val?.totalValueRegister || 0)}
                        </b>
                      </div>
                      <div className="flex">
                        <div>
                          Đã thu:{" "}
                          <b style={{ color: "green" }}>
                            {formatMoney(val?.totalBillPatientPaid || 0)}
                          </b>
                        </div>
                        <span className="mx-2 text-gray-400">|</span>
                        <div>
                          Cần thu:{" "}
                          <b style={{ color: "red" }}>
                            {formatMoney(val?.amountActuallyPaid)}
                          </b>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                field: "price",
                title: "Giá tiền",
                align: "right",
                render: (val) => formatMoney(val?.price),
              },

              {
                field: "practitioner.staffName",
                title: t("Thành tiền"),
                width: "240px",
                render: (data) => {
                  return (
                    <div className="total-data-group">
                      <div className="flex justify-between">
                        Tổng tiền: <b>{formatMoney(data?.price)}</b>
                      </div>
                      <div className="flex justify-between">
                        Giảm giá: <b>{formatMoney(data?.discount)}</b>
                      </div>

                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Số tiền (sau giảm):{" "}
                          <b>
                            {formatMoney(
                              data?.price * data?.quantity -
                                (+data?.discount || 0)
                            )}
                          </b>
                        </b>
                      </div>
                      <div className="flex justify-between">
                        Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                      </div>
                      {data?.oldTreatmentPlanCard?.oldTreatmentCredit && (
                        <div className="flex justify-between">
                          Tiền khấu trừ từ lt cũ:{" "}
                          <b>
                            {formatMoney(
                              +data?.oldTreatmentPlanCard?.oldTreatmentCredit
                            )}
                          </b>
                        </div>
                      )}
                      <div
                        style={{
                          background: "#ccc",
                          width: "100%",
                          height: "1px",
                          margin: "4px 0",
                        }}
                      ></div>
                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Tổng thanh toán:{" "}
                          <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                        </b>
                      </div>
                    </div>
                  );
                },
              },
              // {
              //   field: "clientCard.name",
              //   title: t("Ngày đăng ký"),
              //   render: (val) => getDateTime(val?.orderDate),
              // },
              {
                field: "totalValue",
                title: t("Giá trị được sử dụng"),
                render: (val) => formatMoney(val?.totalValue),
              },
              {
                field: "totalUsed",
                title: t("Giá trị đã sử dụng"),
                render: (val) => formatMoney(val?.totalUsed),
              },
              {
                field: "totalUsed",
                title: t("Số tiền còn lại"),
                render: (val) =>
                  formatMoney(val?.totalValue - (val?.totalUsed || 0)),
              },

              {
                field: "clientCard.name",
                title: t("Ngày đăng ký"),
                render: (val) => getDateTime(val?.startDate),
              },
              {
                field: "clientCard.name",
                title: t("Ngày hết hạn sử dụng"),
                render: (val) => getDateTime(val?.endDate),
              },

              // {
              //   field: "discount",
              //   title: t("Tiền giảm giá"),
              //   render: (val) => formatMoney(val?.discount),
              // },
              {
                field: "department.name",
                title: t("Cơ sở"),
              },
              // {
              //   field: "patient",
              //   title: t("Nguồn"),
              //   render: (row) => {
              //     const sourceName = row?.source?.name;
              //     const sourceDetailName = row?.sourceDetail?.name;
              //     return (
              //       <>
              //         <div>
              //           <div>
              //             {sourceName ? `Nguồn hiện tại: ${sourceName}` : ""}
              //           </div>
              //           <div>
              //             {sourceDetailName
              //               ? `Nguồn chi tiết: ${sourceDetailName}`
              //               : ""}
              //           </div>
              //         </div>
              //       </>
              //     );
              //   },
              // },
              {
                field: "activeStatus",
                title: t("Trạng thái"),
                render: (row) => (
                  <div style={{ textAlign: "center" }}>
                    {row?.cardStatus === ACTIVE_STATUS ? (
                      <Tooltip title="Đang mở">
                        <LockOpenIcon />
                      </Tooltip>
                    ) : row?.cardStatus === LOCKED_STATUS ? (
                      <Tooltip title="Đã khóa">
                        <LockIcon />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                ),
              },
              {
                field: "lockDate",
                title: t("Ngày khóa"),
                render: (row) => getDateTime(row?.lockDate),
              },
              {
                field: "createdBy",
                title: t("Người tạo"),
              },
              {
                field: "modifiedBy",
                title: t("Người sửa"),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },
              {
                field: "note",
                title: t("Ghi chú"),
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataHistory?.totalElements,
              totalPages: pageDataHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryCardPopup));
